import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ErrorHandler, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';

import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';
import { absRoute, ROUTE_ORGANIZATION, ROUTE_PROFILE } from '../app-route.constants';
import { Session } from '../core/session/session';
import { NavigationService, NAV_LEVEL } from './navigation.service';


@Component({
    selector: 'app-toolbar',
    templateUrl: './app-toolbar.component.html',
    styleUrls: ['./app-toolbar.component.scss'],
    standalone: false
})
export class AppToolbarComponent implements OnInit {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly router = inject(Router);
  private readonly navigationService = inject(NavigationService);
  private readonly errorHandler = inject(ErrorHandler);



  @Input()
  showSideBarIcon = false;

  @Input()
  currentUser?: Session;

  @Input()
  appIcon?: string;

  @Output()
  sidebarOpen = new EventEmitter<void>();

  @Output()
  logoutAction = new EventEmitter<void>();

  mobileMode = false;

  level: Observable<NAV_LEVEL>;


  constructor() {
    this.level = this.navigationService.getLevel().pipe(
      delay(0)
    );
  }

  ngOnInit() {
    this.handleSizeChange();
    this.breakpointObserver.observe([Breakpoints.Handset,
    Breakpoints.Tablet, Breakpoints.Web]).subscribe(_v => {
      this.handleSizeChange();
    });
  }

  handleSizeChange() {
    this.mobileMode = this.breakpointObserver.isMatched(Breakpoints.Handset);
  }
  buildTooltip(user?: Session): string {
    if (user) {
      return user.name;
    }
    return '';
  }

  sidebarMenuClick() {
    this.sidebarOpen.emit();
  }

  doLogout() {
    this.logoutAction.emit();
  }

  goToProfile() {
    this.router.navigate([absRoute(ROUTE_PROFILE)]).catch(error => this.errorHandler.handleError(error));
  }

  back() {
    this.router.navigate([absRoute(ROUTE_ORGANIZATION)]).catch(error => this.errorHandler.handleError(error));
  }
}
